// Google Doc where we document this stuff for all MikMak team members to see.
// https://docs.google.com/spreadsheets/d/1OV3xqG3cUMRw2Y70ugIBldchXTLqiyYKvwT_hK21kyY/

export default {
  'pageView': 'PAGE_VIEW',
  'attachGalleryProductToggled': 'ATTACH_GALLERY_PRODUCT_TOGGLED',
  'requestDemoClicked': 'REQUEST_DEMO_CLICKED',
  'solutionLinkClicked': 'SOLUTION_LINK_CLICKED',
  'contactFormSubmitted': 'CONTACT_FORM_SUBMITTED',
  'whitepaperFormSubmitted': 'WHITEPAPER_FORM_SUBMITTED',
  'validEmailInput': 'VALID_EMAIL_INPUT'
}



// WEBPACK FOOTER //
// ./client/events/eventDictionaryStandard.js